import { useQuery } from "react-query";
import http from "infra/http";
import { DashboardRelatorioEmailResponse } from "../typings";
import { ListarFiltroEmailQuery } from "core/features/relatorios/typings";

function useDashboardEmail(filtros: ListarFiltroEmailQuery) {
  return useQuery([`/v1/relatorios/emails/dashboard`, filtros], async () => {
    const { data } = await http.get<DashboardRelatorioEmailResponse>(
      `/v1/relatorios/emails/dashboard`,
      { params: filtros }
    );

    return data;
  });
}
export default useDashboardEmail;
